import Client from './client';

export default class PaymentOrganizationSettings extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  getById(id, options = {}) {
    return this.makeRequest(`${this.host}/internal/organization/settings/${id}`, options);
  }

  putById(id, options = {}) {
    return this.makeRequest(`${this.host}/internal/organization/settings/${id}`, {
      ...options,
       method: 'PUT',
    });
  }

}
